export default __webpack_public_path__ + "static/media/zj0.2e012036.jpg";